export default __webpack_public_path__ + "static/media/building.bc53853b.svg";